import { projects as s } from "../../types/projects/index.js";
import { DaymapQuery as r, DaymapInfiniteQuery as l } from "../daymapQuery.js";
var u;
((o) => {
  class g extends r {
    constructor(e) {
      super(
        ["GetProjectConfig", e.id],
        e,
        `/lms/api/projects/configuration/${e.id}`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => ({
            ...n,
            Flags: n.Flags,
            ProjectConfigPermissions: new s.ProjectConfigPermissions(n.ProjectConfigPermissions)
          }),
          enabled: !!e.id
        }
      );
    }
  }
  o.GetProjectConfig = g;
  class P extends r {
    constructor(e) {
      super(
        ["GetProjectForms", e.configId, e.admin],
        e,
        `/lms/api/projects/configuration/${e.configId}/forms${e.admin ? "?admin=true" : ""}`,
        null,
        { stale: 1e3 * 60 * 10, enabled: !!e.configId }
      );
    }
  }
  o.GetProjectForms = P;
  class f extends r {
    constructor(e) {
      super(
        ["GetProjectsForStudent", e.configId, e.studentId],
        e,
        `/lms/api/projects/${e.configId}/students/${e.studentId}`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  o.GetProjectsForStudent = f;
  class j extends r {
    constructor(e) {
      super(
        ["GetProject", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/details`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n && { ...n, Created: new Date(n.Created), Modified: n.Modified ? new Date(n.Modified) : null },
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProject = j;
  class I extends r {
    constructor(e) {
      super(
        ["GetProjectPeople", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/people`,
        null,
        {
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectPeople = I;
  class S extends r {
    constructor(e) {
      super(
        ["GetProjectRecordForStudent", e.projectId, e.studentId],
        e,
        `/lms/api/projects/${e.projectId}/records/${e.studentId ? e.studentId : "0"}`,
        null,
        {
          select: (n) => n.map((t) => ({ ...t, Created: new Date(t.Created), Modified: t.Modified ? new Date(t.Modified) : null })),
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectRecordForStudent = S;
  class m extends r {
    constructor(e) {
      super(
        ["GetProjectEventsForStudent", e.projectId, e.studentId],
        e,
        `/lms/api/projects/${e.projectId}/events/${e.studentId ? e.studentId : "0"}`,
        null,
        {
          select: (n) => n.map((t) => ({ ...t, Start: new Date(t.Start), End: new Date(t.End) })),
          stale: 1e3 * 60 * 10,
          enabled: !!e.projectId
        }
      );
    }
  }
  o.GetProjectEventsForStudent = m;
  class G extends r {
    constructor(e) {
      super(
        ["GetProjectListForStudent", e.configId, e.studentId],
        e,
        `/lms/api/projects/list/${e.configId}${e.studentId ? `?studentId=${e.studentId}` : ""}`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((t) => ({
            ...t,
            Created: new Date(t.Created),
            NextEvent: t.NextEvent ? new Date(t.NextEvent) : void 0,
            Recurrence: t.Recurrence ? { ...t.Recurrence, Start: new Date(t.Recurrence.Start) } : void 0,
            RecentEvents: (t.RecentEvents || []).map((a) => ({
              ...a,
              Start: new Date(a.Start),
              End: a.End ? new Date(a.End) : a.End
            }))
          }))
        }
      );
    }
  }
  o.GetProjectListForStudent = G;
  class C extends r {
    constructor(e) {
      super(
        ["GetAllProjectConfigs"],
        e,
        "/lms/api/projects/configuration/all",
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((c) => ({
            ...c,
            Flags: c.Flags,
            ProjectConfigPermissions: new s.ProjectConfigPermissions(c.ProjectConfigPermissions)
          }))
        }
      );
    }
  }
  o.GetAllProjectConfigs = C;
  class x extends r {
    constructor(e) {
      super(
        ["CreateProjectConfig"],
        e,
        "/lms/api/projects/configuration",
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.CreateConfig = x;
  class $ extends r {
    constructor(e) {
      super(
        ["UpdateProjectConfig", e.data.Id],
        e,
        `/lms/api/projects/configuration/${e.data.Id}`,
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.UpdateConfig = $;
  class D extends r {
    constructor(e) {
      super(
        ["DeleteProjectConfig", e.Id],
        e,
        `/lms/api/projects/configuration/${e.Id}/delete`,
        null,
        {
          enabled: !1
        }
      );
    }
  }
  o.DeleteConfig = D;
  class F extends r {
    constructor(e) {
      super(
        ["GetAllNotificationConfigs", e.configId],
        e,
        `/lms/api/projects/notifications/${e.configId}/all`,
        null,
        { stale: 1e3 * 60 * 10 }
      );
    }
  }
  o.GetAllNotificationConfigs = F;
  class w extends r {
    constructor(e) {
      super(
        ["GetProjectLogs", e.projectId],
        e,
        `/lms/api/projects/${e.projectId}/logs`,
        null,
        {
          stale: 1e3 * 60 * 10,
          select: (n) => n.map((t) => ({ ...t, Changed: new Date(t.Changed), ActionType: t.ActionType }))
        }
      );
    }
  }
  o.GetProjectLogs = w;
  class R extends l {
    constructor(e) {
      const n = e.dateField ?? 0, c = e.pageSize ?? 50;
      super(
        ["GetProjectAdminReportPaged", e.configId, n, e.from, e.to, c],
        e,
        `/lms/api/projects/reports/${e.configId}/admin`,
        null,
        {
          infiniteQueryUrl: (t) => {
            const a = new URLSearchParams({
              dateField: n.toString(),
              pageSize: c.toString(),
              pageIndex: t.toString()
            });
            return e.from && a.append("from", e.from.toISOString()), e.to && a.append("to", e.to.toISOString()), `/lms/api/projects/reports/${e.configId}/admin?${a.toString()}`;
          },
          getNextPageParam: (t) => {
            const a = Math.ceil(t.TotalCount / t.PageSize), i = t.PageIndex + 1;
            return i <= a ? i : void 0;
          },
          initialPageParam: 1,
          stale: 1e3 * 60 * 10
        }
      );
    }
  }
  o.GetProjectAdminReportPaged = R;
  class v extends l {
    constructor(e) {
      const n = e.dateField ?? 0, c = e.pageSize ?? 50;
      super(
        ["GetProjectStudentReportPaged", e.configId, e.studentId, n, e.from, e.to, c],
        e,
        `/lms/api/projects/reports/${e.configId}/student/${e.studentId}`,
        null,
        {
          infiniteQueryUrl: (t) => {
            const a = new URLSearchParams({
              dateField: n.toString(),
              pageSize: c.toString(),
              pageIndex: t.toString()
            });
            return e.from && a.append("from", e.from.toISOString()), e.to && a.append("to", e.to.toISOString()), `/lms/api/projects/reports/${e.configId}/student/${e.studentId}?${a.toString()}`;
          },
          getNextPageParam: (t) => {
            const a = Math.ceil(t.TotalCount / t.PageSize), i = t.PageIndex + 1;
            return i <= a ? i : void 0;
          },
          initialPageParam: 1,
          stale: 1e3 * 60 * 10
        }
      );
    }
  }
  o.GetProjectStudentReportPaged = v;
})(u || (u = {}));
export {
  u as projects
};
//# sourceMappingURL=index.js.map
